import styled from '@emotion/styled';
import { useAtom } from'jotai';
import { useRef, useEffect, useState } from 'react';
import { selectedImagesAtom ,sendingPhotoArrAtom } from '../../newOnboardingAtom';
import ReactGA from "react-ga4";
import ReturnModal from "./ReturnModal";

interface PhotoContainerProps {
  // onSelectedPhotos: (photos: string[]) => void;
}
// onSelectedPhotos
const PhotoContainer:React.FC<PhotoContainerProps> = () => {
  const [ showModal, setShowMoal ] = useState(false);
  const [selectedImage, setSelectedImage] = useAtom(selectedImagesAtom);
  const [sendingPhoto, setSendingPhoto] = useAtom(sendingPhotoArrAtom);
  const fileInputRef = useRef(null);
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

  const handlePhotoButtonClick = async () => {
    //@ts-ignore
    await fileInputRef.current.click();
  };

  const closeModal = () => {
    if (showModal === true ) {
      setShowMoal(false);
    }
  }

  const handleModal = () => {
    setShowMoal(true);
  }

  const handleFileSelect = (e: any) => {
    const files = e.target.files;
    // if (gaId) {
    //   ReactGA.initialize(gaId);
    //   ReactGA.event({
    //     "category": "Button",
    //     "action" : "Click",
    //     "label" : "upload Photo FreeKit"
    //   })
    // }

    let modifiedFiles:any;
    let selectedFilesArr:any = [];
    if (files.length < 5) {
      selectedFilesArr = []
      setSelectedImage(selectedFilesArr);
    } 
    else if (files.length >= 5) {
      modifiedFiles = Array.from(files).slice(0,5);
      for (let i=0; i < modifiedFiles.length; i++) {
        const file = files[i];
        selectedFilesArr.push(URL.createObjectURL(file));
      }
      setSelectedImage(selectedFilesArr);
      setSendingPhoto(modifiedFiles)
    }
  };  

  useEffect(() => {
    setSelectedImage(selectedImage)
  }, [])
  
  return (
    <>
    {selectedImage.length > 0 ? (
      <Container>
        <UnselectdPhotoWrapper>
          <SquareWrapper
            onClick={handleModal}
          >
            <ButtonTextContainer>
              <div className="plus">+</div>
              <div className="context">사진 변경</div>
            </ButtonTextContainer>
            {/* <input 
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              multiple
              onChange={handleFileSelect}
              name="filename"
              max="5"
            /> */}
          </SquareWrapper>
          <SquareWrapper
          >
            {selectedImage.length > 0 && (
              <SelectPhotoWrapper src={selectedImage[0]} />
            )}
          </SquareWrapper>
          <SquareWrapper>
            {selectedImage.length > 1 && (
              <SelectPhotoWrapper src={selectedImage[1]} />
            )}
          </SquareWrapper>
        </UnselectdPhotoWrapper>
        <UnselectdPhotoWrapper>
          <SquareWrapper>
            {selectedImage.length > 2 && (
              <SelectPhotoWrapper src={selectedImage[2]} />
            )}
          </SquareWrapper>
          <SquareWrapper>
            {selectedImage.length > 3 && (
              <SelectPhotoWrapper src={selectedImage[3]} />
            )}
          </SquareWrapper>
          <SquareWrapper>
            {selectedImage.length > 4 && (
              <SelectPhotoWrapper src={selectedImage[4]} />
            )}
          </SquareWrapper>
        </UnselectdPhotoWrapper>
      </Container>
      ):(
        <Container>
          <UnselectdPhotoWrapper>
            <SquareWrapper
            onClick={handleModal}
            >
              <ButtonTextContainer>
                <div className="plus">+</div>
                <div className="context">사진 추가</div>
              </ButtonTextContainer>
              {/* <input 
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                multiple
                max="5"
                onChange={handleFileSelect}
              /> */}
            </SquareWrapper>
            <SquareWrapper />
            <SquareWrapper />
          </UnselectdPhotoWrapper>
          <UnselectdPhotoWrapper>
            <SquareWrapper />
            <SquareWrapper />
            <SquareWrapper />
          </UnselectdPhotoWrapper>
          {showModal && <ReturnModal showModal={showModal} closeModal={closeModal}/>}
        </Container>
      )}
    </>
  );
};

export default PhotoContainer;

const Container = styled.div`
  width: 100%;
  
  height: 210px;
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  justify-content: space-between;


  @media (max-width:321px) {
    height: 100%;
  }
`
const SelectPhotoWrapper = styled.img`
  width: 100%;
  height: 100%;
  object-fit:cover;
`
const UnselectdPhotoWrapper = styled.div`
  width: 100%;
  
  @media (max-width:321px) {
    height: 120px;
  }

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* margin: 0 auto; */
`
const SquareWrapper = styled.div`
  /* max-width: 98px; */
  width: 32%;
  /* height: 95%; */
  aspect-ratio: 1/1;
  margin-bottom: 5px;
  background-color: white;
  border-radius: 5px;
  
  
  &.button {
    position: absolute;
  }

  @media (max-width: 321px) {
    width: 49% ;
    aspect-ratio: 1/1;
    /* height: 80px; */
  }
`
const ButtonTextContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #535353;
  opacity: 0.5;

  div {
    &.plus{
      color: rgba(155, 155, 155, 1);
      font-size: 30px;
      margin-bottom: 1.5px;
      
    }
  }
`